import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

// Import images from assets folder
import seamlessicon from "./images/seamlessicon.webp";
import icon2 from "./images/icon2.webp";
import icon3 from "./images/icon3.webp";
import icon4 from "./images/icon4.webp";
import icon5 from "./images/icon5.webp";
import icon6 from "./images/icon6.webp";

// Feature list with imported images
const features = [
  { title: "Seamless Information Exchange", icon: seamlessicon },
  { title: "Comprehensive Data Management", icon: icon2 },
  { title: "Enhanced Sourcing Capabilities", icon: icon3 },
  { title: "Real-Time Insights & Decision Making", icon: icon4 },
  { title: "Dynamic Pitching Solutions", icon: icon5 },
  { title: "Organized Data to Work Efficiently", icon: icon6 }
];

const FeatureSection = () => {
  return (
    <div className="container py-5">
      {/* Section Header */}
      <div className="text-center mb-4">
        <p className="futuretle">FUTURE</p>
        <h2 className="futurepara">
          Experience the <span className="textpurple">Future of Data <br /> Collaboration</span> with Toodhu
        </h2>
      </div>

      {/* Feature Cards */}
      <div className="row g-4">
        {features.map((feature, index) => (
          <div key={index} className="col-md-6 col-lg-4">
            <div className="feature-card p-4 rounded shadow-sm bg-light">
              <div className="icon mb-3">
                <img src={feature.icon} alt={feature.title} className="img-fluid" width="40" />
              </div>
              <h5>{feature.title}</h5>
              <p className="text-muted">
                Lorem ipsum is simply dummy text of the printing and typesetting industry.
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeatureSection;